const BACKEND_URL_ENV_NAME = 'REACT_APP_BACKEND_URL';

export function getBackendUrl(rawBackendUrl = process.env.REACT_APP_BACKEND_URL) {
  const backendUrl = typeof rawBackendUrl === 'string' ? rawBackendUrl.trim() : '';

  if (!backendUrl) {
    throw new Error(`${BACKEND_URL_ENV_NAME} must be configured before making API requests.`);
  }

  let parsedUrl;
  try {
    parsedUrl = new URL(backendUrl);
  } catch {
    throw new Error(`${BACKEND_URL_ENV_NAME} must be a valid absolute HTTP(S) URL.`);
  }

  if (!['http:', 'https:'].includes(parsedUrl.protocol)) {
    throw new Error(`${BACKEND_URL_ENV_NAME} must use HTTP or HTTPS.`);
  }

  return backendUrl.replace(/\/+$/, '');
}

export function getApiBaseUrl(rawBackendUrl = process.env.REACT_APP_BACKEND_URL) {
  return `${getBackendUrl(rawBackendUrl)}/api`;
}

export function getApiUrl(path, rawBackendUrl = process.env.REACT_APP_BACKEND_URL) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getApiBaseUrl(rawBackendUrl)}${normalizedPath}`;
}
